import type { RenderingKind } from '@haaretz/s-types';

export default function isBlockedArticle(renderingKind: RenderingKind) {
  return renderingKind === 'blocked' || renderingKind === 'semi-closed';
}
